import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\GetDocumentByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentByIdController.php
* @route '/api/document/{document}'
*/
const GetDocumentByIdController = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentByIdController.url(args, options),
    method: 'get',
})

GetDocumentByIdController.definition = {
    methods: ["get","head"],
    url: '/api/document/{document}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\GetDocumentByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentByIdController.php
* @route '/api/document/{document}'
*/
GetDocumentByIdController.url = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { document: args }
    }

    if (Array.isArray(args)) {
        args = {
            document: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        document: args.document,
    }

    return GetDocumentByIdController.definition.url
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetDocumentByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentByIdController.php
* @route '/api/document/{document}'
*/
GetDocumentByIdController.get = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\GetDocumentByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentByIdController.php
* @route '/api/document/{document}'
*/
GetDocumentByIdController.head = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDocumentByIdController.url(args, options),
    method: 'head',
})

export default GetDocumentByIdController